import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, MapPin } from 'lucide-react';
import { LANDING_PAGES, CASE_STUDIES, LEGAL_PAGES, landingPath, casePath, legalPath, homePath } from '../seo/seoConfig';

const linkClass = 'inline-flex items-center gap-1 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors';

// Crawlable cross-links between regional pages, case studies, contact and legal pages
export const RelatedLinks = ({ lang, excludeLanding, excludeCase }) => {
  const { t } = useTranslation();
  const regions = Object.keys(LANDING_PAGES).filter((k) => k !== excludeLanding);
  const cases = CASE_STUDIES.filter((c) => c.slug !== excludeCase);

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-gray-800" data-testid="related-links">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <nav aria-label={t('links.regions')}>
          <p className="text-xs font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-400 mb-3">{t('links.regions')}</p>
          <ul className="space-y-2">
            {regions.map((key) => (
              <li key={key}>
                <Link to={landingPath(lang, key)} className={linkClass} data-testid={`related-landing-${key}`}>
                  <MapPin className="h-3.5 w-3.5" /> {t(`${LANDING_PAGES[key].i18nKey}.h1`)}
                </Link>
              </li>
            ))}
            <li>
              <Link to={`${homePath(lang)}#contact`} className={linkClass} data-testid="related-contact">
                <ArrowRight className="h-3.5 w-3.5" /> {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </nav>
        <nav aria-label={t('links.projects')}>
          <p className="text-xs font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-400 mb-3">{t('links.projects')}</p>
          <ul className="space-y-2">
            {cases.map((c) => (
              <li key={c.slug}>
                <Link to={casePath(lang, c.slug)} className={linkClass} data-testid={`related-case-${c.slug}`}>
                  <ArrowRight className="h-3.5 w-3.5" /> {t(`projectData.${c.i18nKey}.title`)}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label={t('links.legal')}>
          <p className="text-xs font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-400 mb-3">{t('links.legal')}</p>
          <ul className="space-y-2">
            {Object.keys(LEGAL_PAGES).map((key) => (
              <li key={key}>
                <Link to={legalPath(lang, key)} className={linkClass} data-testid={`related-legal-${key}`}>
                  <ArrowRight className="h-3.5 w-3.5" /> {t(LEGAL_PAGES[key].footerKey)}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-4 text-xs text-gray-500 dark:text-gray-500">{t('links.servedFrom')} Hägendorf, Olten, Solothurn.</p>
        </nav>
      </div>
    </section>
  );
};
